import { useNavigate } from 'react-router-dom';
import ContactUsModel from 'src/components/Modals/ContactUsModel';
import TermsAndConditionModal from 'src/components/Modals/TermsAndConditionModal';
import React, { useEffect, useState } from 'react';
import moment from 'moment';

function AppFooter() {
  const navigate = useNavigate();
  const [ContactUsModal, setContactUsModal] = useState(false);
  const [termsmodalOpen, setTermsmodalOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const toggleContactUsMdl = () => {
    setContactUsModal((prev) => !prev);
  };
  const AddContactUsClick = () => {
    toggleContactUsMdl(true);
  };
  // Toggle modal state
  const toggleModal = () => {
    setModalOpen((prev) => !prev);
  };

  // Function to handle Terms and Condition modal
  const TermsModal = () => {
    setTermsmodalOpen((prev) => !prev);
  };

  const toFbProfile = () => {
    window.open(
      'https://www.facebook.com/profile.php?id=61554023558745&is_tour_dismissed=true',
      '_blank',
    );
  };
  const toInstaProfile = () => {
    window.open('https://www.instagram.com/4Dims_official/', '_blank');
  };
  const toTwitterProfile = () => {
    window.open('https://x.com/@4Dims_official', '_blank');
  };
  const toPlayStore = () => {
    window.open('https://play.google.com/store/apps/details?id=com.blazor.dsps', '_blank');
  };

  const toAppleStore = () => {
    window.open('https://apps.apple.com/us/app/4-delivery-service-partners/id6618150968', '_blank');
  };
  return (
    <React.Fragment>
      <div className="BottomView">
        <div className="row">
          <div className="col-md-4 order1">
            <a className="labelName pointer" onClick={() => navigate('/dspRegister')}>
              Register DSP
            </a>
          </div>
          <div className="col-md-4 order3">
            <img
              onClick={toAppleStore}
              className="PlaySoreIcon pointer"
              src="AppStore.png"
              alt="logo"
            />
            <img
              onClick={toPlayStore}
              className="PlaySoreIcon pointer"
              src="GooglePlaystore.png"
              alt="logo"
            />
          </div>
          <div className="col-md-4 order2">
            <a onClick={AddContactUsClick} className="labelName pointer">
              Contact Us
            </a>
          </div>
        </div>

        <div className="row">
          <div className="col-md-4 order1">
            <a className="labelName pointer" onClick={() => navigate('/AddDA')}>
              Apply for Delivery Associate
            </a>
          </div>
          <div className="col-md-4 order3">
            <img
              onClick={toInstaProfile}
              className="socialMediaIcon pointer"
              src="instagram.png"
              alt="logo"
            />
            <img
              onClick={toTwitterProfile}
              className="socialMediaIcon pointer"
              src="x.png"
              alt="logo"
              style={{
                filter: 'brightness(0) invert(1)', // Turns the image white
              }}
            />
            <img
              onClick={toFbProfile}
              className="socialMediaIcon pointer"
              src="facebook.png"
              alt="logo"
            />
          </div>
          <div className="col-md-4 order2">
            <a className="labelName pointer" onClick={() => navigate('/PrivacyPolicy')}>
              Policy Statement
            </a>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4 order1">
            <a className="labelName pointer" href="#/faqs">
              FAQs
            </a>
          </div>
          <div className="col-md-4 order3">
            <span className="market-button-subtitle labelName">
              © {moment().format('YYYY')}, 6BY7. All Rights Reserved
            </span>
          </div>
          <div className="col-md-4 order2">
            <a onClick={TermsModal} className="labelName pointer">
              Terms of Use
            </a>
          </div>
        </div>
      </div>

      <ContactUsModel
        isOpen={ContactUsModal}
        toggle={toggleContactUsMdl}
        header="Contact Us"
        //  isSubTask={false}
        //  tasksData={data?.data}
        //  fetchWorkflowTask={fetchWorkflowTask}
      />
      <TermsAndConditionModal isOpen={termsmodalOpen} toggle={TermsModal} />
    </React.Fragment>
  );
}
export default AppFooter;
